import React from 'react';
import { FileText, Timer, Clock, Watch, Hourglass, TimerIcon } from 'lucide-react';
import { TEMPLATE_TYPE_ICONS, TemplateType } from '@/constants/templateTypes';

const lengthIconMap = {
  'ultra-short': Timer,
  'short': TimerIcon,
  'medium': Clock,
  'medium-long': Watch,
  'long': Hourglass,
  'very-long': Timer
} as const;

export const getTemplateIcon = (iconName: string) => {
  // First check if it's a length icon
  if (lengthIconMap[iconName as keyof typeof lengthIconMap]) {
    const IconComponent = lengthIconMap[iconName as keyof typeof lengthIconMap];
    return <IconComponent className="h-4 w-4 mr-2" />;
  }
  
  // Then check if it's a template type icon
  const IconComponent = TEMPLATE_TYPE_ICONS[iconName as TemplateType] || FileText;
  return <IconComponent className="h-4 w-4 mr-2" />;
}; 